const sections = {
  Carrier: {
    value: 'CARRIER',
    label: 'form.driver.carrier'
  },
  BasicDetails: {
    value: 'BASIC_DETAILS',
    label: 'form.driver.basicDetails'
  },
  AdditionalDetails: {
    value: 'ADDITIONAL_DETAILS',
    label: 'form.driver.additionalDetails'
  },
  Files: {
    value: 'FILES',
    label: 'form.driver.files'
  }
}
export default sections
